define("shared/components/shared/mavely/links/mobile-tabs", ["exports", "@ember/component", "@ember/component/template-only", "@ember/template-factory"], function (_exports, _component, _templateOnly, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = _exports.MavelyLinksMobileTabsComponent = void 0;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/component/template-only",0,"@ember/component"eaimeta@70e063a35619d71f
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <ul class="o--nav--underline cLB--section__nav cLB--section__nav--mobile" data-test-id="tabs">
    <li class="o--nav__item cLB--section__navItem u--col__6">
      <Shared::Ui::Button
        @additional="block"
        @class={{concat-classes "o--nav__link u--p__tb__md" (unless @isFoldersTabActive "is--active")}}
        @onClick={{fn @setActiveFoldersTab false}}
        @text={{t "mavely.links_modal.folders.all_links"}}
        @variant="unstyled"
        data-test-id="mavely-links-all-links-tab"
      />
    </li>
    <li class="o--nav__item cLB--section__navItem u--col__6">
      <Shared::Ui::Button
        @additional="block"
        @class={{concat-classes "o--nav__link u--p__tb__md" (if @isFoldersTabActive "is--active")}}
        @onClick={{fn @setActiveFoldersTab true}}
        @text={{t "mavely.links_modal.folders.tab_title"}}
        @variant="unstyled"
        data-test-id="mavely-links-folders-tab"
      />
    </li>
  </ul>
  */
  {
    "id": "c0ypFXgW",
    "block": "[[[10,\"ul\"],[14,0,\"o--nav--underline cLB--section__nav cLB--section__nav--mobile\"],[14,\"data-test-id\",\"tabs\"],[12],[1,\"\\n  \"],[10,\"li\"],[14,0,\"o--nav__item cLB--section__navItem u--col__6\"],[12],[1,\"\\n    \"],[8,[39,0],[[24,\"data-test-id\",\"mavely-links-all-links-tab\"]],[[\"@additional\",\"@class\",\"@onClick\",\"@text\",\"@variant\"],[\"block\",[28,[37,1],[\"o--nav__link u--p__tb__md\",[52,[51,[30,1]],\"is--active\"]],null],[28,[37,3],[[30,2],false],null],[28,[37,4],[\"mavely.links_modal.folders.all_links\"],null],\"unstyled\"]],null],[1,\"\\n  \"],[13],[1,\"\\n  \"],[10,\"li\"],[14,0,\"o--nav__item cLB--section__navItem u--col__6\"],[12],[1,\"\\n    \"],[8,[39,0],[[24,\"data-test-id\",\"mavely-links-folders-tab\"]],[[\"@additional\",\"@class\",\"@onClick\",\"@text\",\"@variant\"],[\"block\",[28,[37,1],[\"o--nav__link u--p__tb__md\",[52,[30,1],\"is--active\"]],null],[28,[37,3],[[30,2],true],null],[28,[37,4],[\"mavely.links_modal.folders.tab_title\"],null],\"unstyled\"]],null],[1,\"\\n  \"],[13],[1,\"\\n\"],[13]],[\"@isFoldersTabActive\",\"@setActiveFoldersTab\"],false,[\"shared/ui/button\",\"concat-classes\",\"unless\",\"fn\",\"t\",\"if\"]]",
    "moduleName": "shared/components/shared/mavely/links/mobile-tabs.hbs",
    "isStrictMode": false
  });
  const MavelyLinksMobileTabsComponent = _exports.MavelyLinksMobileTabsComponent = (0, _templateOnly.default)();
  var _default = _exports.default = (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, MavelyLinksMobileTabsComponent);
});